import React, { useEffect } from 'react';

import { Checkbox, FormControlLabel, FormGroup, FormLabel } from '@mui/material';

/**
 *  Convert a string using '0' or '1' to a list of checkbox
 * '0' => unchecked
 * '1' => checked
 * String : '010' will lead to 3 checkboxes
 * @param {String} label: Label of the group of checkbox
 * @param {object} stringValues: The string using '0' and '1' | ex '001'
 * @param {string[]} items: Labels of the checkboxes
 * @param {String} name: name of the field for Formik
 * @param {function} setFieldValue: comes from Formik
 *
 * @returns {DOM} Return component
 */
const StringToCheckBoxGroup = ({ label, stringValues, items, name, setFieldValue }) => {
  useEffect(() => {
    if (stringValues === null) {
      setFieldValue(name, '0'.repeat(items.length));
    }
  }, [stringValues, items, setFieldValue, name]);

  /**
   *
   * Update the char at 'at' in the 'stringValues' to the value 'checked' (ie '1' or '0')
   *
   * @param {boolean} checked: new value
   * @param {number} at: index where the value changes
   * @returns {string} the new value
   */
  const updateValueAt = (checked, at) => {
    return stringValues
      .split('')
      .map((char, index) => {
        if (at === index) {
          return checked ? '1' : '0';
        }

        return char;
      })
      .join('');
  };

  if (stringValues === null) {
    return null;
  }

  return (
    <FormGroup row>
      <FormLabel component='legend'>{label} :</FormLabel>
      {items.map((item, index) => (
        <FormControlLabel
          key={item}
          variant='outlined'
          size='small'
          fullWidth
          control={
            <Checkbox
              checked={stringValues[index] === '1'}
              onChange={e => {
                setFieldValue(name, updateValueAt(e.target.checked, index));
              }}
            />
          }
          label={item}
        />
      ))}
    </FormGroup>
  );
};

export default StringToCheckBoxGroup;
